import React, { useState, useEffect } from 'react';
import { MdClose } from 'react-icons/md';
import { toast } from 'react-toastify';

import { trackCorreios } from '~/services/traking';
import {
    listTrackingCodes,
    persistTrackingCode,
    removeTrackingCode,
} from '~/services/traking/persist';

import { Container, Image, Form, TrackingContainer, CodesList } from './styles';

import TrackingList from './TrackingList';
import TrackInput from './TrackInput';
import SaveCode from './SaveCode';

import logo from '~/assets/images/logo.svg';

function Rastreamento() {
    const [tracking, setTracking] = useState(false);
    const [trackingCode, setTrackingCode] = useState('');
    const [codeName, setCodeName] = useState('');
    const [codeList, setCodeList] = useState([]);
    const [trackingList, setTrackingList] = useState([]);

    function handleDelete(code) {
        removeTrackingCode(code);

        const persisted = listTrackingCodes();

        setCodeList(persisted);
    }

    async function handleSubmit(e) {
        e.preventDefault();
        const saveCode = e.target.querySelector('#checkbox-code-save');
        const name = codeName;
        const code = trackingCode;

        if (saveCode.checked) {
            setCodeList(persistTrackingCode({ name, code }));
        }

        const track = await trackCorreios(code);

        if (!track.error) {
            setTrackingList(track);

            setTracking(true);
        } else {
            toast.error(track.error);
        }
    }

    async function handleSearchSavedCode({ code, name }) {
        document.querySelector('#checkbox-code-save').checked = true;

        setTrackingCode(code);
        setCodeName(name);

        const track = await trackCorreios(code);

        // console.log('TRACK:', track);

        setTrackingList(track);

        if (track) {
            setTracking(true);
        }
    }
    useEffect(() => {
        const persisted = listTrackingCodes();

        setCodeList(persisted);

        document.body.addEventListener('keyup', evt => {
            if (evt.key === 'Enter') {
                document.querySelector('#tracking-button').click();
            }
        });
    }, []);

    return (
        <Container>
            <TrackingContainer
                tracking={tracking}
                className={tracking ? 'active' : ''}
            >
                <Image
                    src={logo}
                    className={tracking ? 'active' : ''}
                    alt="Rastreamento by Mercado Mail"
                />
                <Form
                    id="form-tracking"
                    onSubmit={handleSubmit}
                    className={tracking ? 'active' : ''}
                >
                    <div className="inputs-container">
                        <TrackInput
                            trackingCode={trackingCode}
                            onCodeChange={setTrackingCode}
                        />
                        <SaveCode name={codeName} onNameChange={setCodeName} />
                    </div>
                    <CodesList>
                        {codeList.map((code, index) => (
                            <li key={String(index)}>
                                <button
                                    className="button-label"
                                    type="button"
                                    onClick={() =>
                                        handleSearchSavedCode({
                                            code: code.code,
                                            name: code.name,
                                        })
                                    }
                                >
                                    {!code.name ? code.code : code.name}
                                </button>
                                <button
                                    className="code-remove"
                                    type="button"
                                    onClick={() => handleDelete(code.code)}
                                >
                                    <MdClose />
                                </button>
                            </li>
                        ))}
                    </CodesList>
                </Form>
            </TrackingContainer>
            <TrackingList
                classes={tracking ? 'active' : ''}
                trackingType="Correios"
                trackingList={trackingList}
            />
        </Container>
    );
}

export default Rastreamento;
